import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import PayrollReceiptSheet from "@/components/PayrollReceiptSheet";
import { Printer, ArrowLeft, Share2 } from "lucide-react";
import { toast } from "sonner";

export default function PayrollReceipt() {
  const { id } = useParams();
  const [entry, setEntry] = useState(null);
  const [error, setError] = useState("");

  const load = async () => {
    try {
      const { data } = await api.get(`/payroll/${id}`);
      setEntry(data);
    } catch (err) {
      setError(err.response?.data?.detail || "No se pudo cargar el recibo");
    }
  };
  useEffect(() => { load(); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const submitSignature = async (dataUrl) => {
    try {
      await api.post(`/payroll/${id}/sign`, { signature: dataUrl });
      toast.success("Recibo firmado de conformidad");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "No se pudo guardar la firma");
      throw e;
    }
  };

  const share = async () => {
    try {
      const { data } = await api.post(`/payroll/${id}/share`);
      const url = `${window.location.origin}/firma/nomina/${data.token}`;
      try { await navigator.clipboard.writeText(url); } catch { /* noop */ }
      toast.success("Enlace de firma copiado (válido 7 días). Compártelo por WhatsApp.");
      window.open(`https://wa.me/?text=${encodeURIComponent(`Recibo de nómina de ${entry.employee?.name || entry.employee_name} (${entry.period_start} → ${entry.period_end}) — firma de recibido: ${url}`)}`, "_blank");
    } catch (e) {
      toast.error(e.response?.data?.detail || "No se pudo generar el enlace");
    }
  };

  if (error) return <div className="min-h-screen flex items-center justify-center text-slate-300">{error}</div>;
  if (!entry) return <div className="min-h-screen flex items-center justify-center text-slate-400 label-mono">Cargando…</div>;

  return (
    <div className="min-h-screen" style={{ background: "#0a0f1d" }}>
      <div className="no-print sticky top-0 z-10 px-6 py-3 flex items-center justify-between gap-2 flex-wrap"
        style={{ borderBottom: "1px solid var(--border)", background: "rgba(5,8,18,0.9)", backdropFilter: "blur(8px)" }}>
        <button onClick={() => window.history.back()} className="btn-ghost px-3 py-1.5 text-xs uppercase tracking-widest font-semibold rounded-sm flex items-center gap-2">
          <ArrowLeft className="w-4 h-4" /> Volver
        </button>
        <div className="flex items-center gap-2">
          <button data-testid="share-receipt-btn" onClick={share} className="btn-ghost px-4 py-2 text-xs uppercase tracking-widest font-semibold rounded-sm flex items-center gap-2" style={{ color: "var(--green)", borderColor: "var(--green)" }}>
            <Share2 className="w-4 h-4" /> Compartir para firmar
          </button>
          <button data-testid="print-receipt-btn" onClick={() => window.print()} className="btn-primary px-4 py-2 text-xs uppercase tracking-widest font-semibold rounded-sm flex items-center gap-2">
            <Printer className="w-4 h-4" /> Imprimir / Guardar PDF
          </button>
        </div>
      </div>
      <div className="py-8 px-4">
        <PayrollReceiptSheet entry={entry} submitSignature={submitSignature} />
      </div>
    </div>
  );
}
